import React from "react";
import { ArrowRight, Aperture, Layers, Maximize2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const narratives = [{
  id: 1,
  title: "The Silent Coast",
  filmStock: "Ilford HP5 Plus",
  location: "Pacific Northwest",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556059/img/narrative_coast.png",
  link: "/TheArchivesPage",
  description: "A monochromatic study of fog, rock, and the eternal motion of the sea."
}, {
  id: 2,
  title: "Neon Nocturne",
  filmStock: "Cinestill 800T",
  location: "Tokyo, Japan",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556059/img/narrative_neon.png",
  link: "/TheArchivesPage",
  description: "Capturing the electric soul of the city after midnight in tungsten balance."
}, {
  id: 3,
  title: "Desert Solitaire",
  filmStock: "Kodak Portra 400",
  location: "Mojave Desert",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556059/img/narrative_desert.png",
  link: "/TheArchivesPage",
  description: "Warm hues and harsh shadows exploring isolation in the American West."
}];
export default function CuratedNarratives() {
  return <section id="curated-narratives" className="dark bg-background text-foreground py-24 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="mb-20 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl font-serif font-medium tracking-tight mb-6">
              Curated Narratives
            </h2>
            <p className="text-muted-foreground text-lg font-light leading-relaxed max-w-xl">
              Selected works from the archive. Each collection is a study in light,
              chemistry, and time—presented exactly as captured on the emulsion.
            </p>
          </div>
          <div className="hidden md:block pb-2">
            <Button variant="outline" className="rounded-full px-8 border-white/20 hover:bg-white/10 hover:text-white" asChild>
              <Link to="/TheArchivesPage">
                View All Archives <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="flex flex-row flex-wrap justify-center gap-x-16 gap-y-12">
          {narratives.map((item, i) => <div key={item.id} data-index={i} className={`
                flex flex-col w-full md:w-[calc(33.333%-43px)]
                ${i === 0 ? "md:mt-0" : ""}
                ${i === 1 ? "md:mt-32" : ""}
                ${i === 2 ? "md:mt-16" : ""}
              `}>
              <Link to={item.link} className="group block w-full">
                <Card className="bg-transparent border-0 shadow-none overflow-hidden rounded-none relative">
                  <CardContent className="p-0">
                    <AspectRatio ratio={2 / 3} className="relative overflow-hidden bg-muted">
                      {}
                      <img src={item.image} alt={item.title} className="object-cover w-full h-full grayscale transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-[0.3]" />

                      {}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />

                      {}
                      <div className="absolute top-6 right-6 translate-y-[-10px] opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 delay-100">
                        <div className="bg-black/40 backdrop-blur-md border border-white/10 px-3 py-1.5 text-xs font-mono tracking-wider uppercase text-white/90 flex items-center gap-2">
                          <Aperture className="h-3 w-3" />
                          {item.filmStock}
                        </div>
                      </div>

                      {}
                      <div className="absolute bottom-0 left-0 w-full p-8 transition-transform duration-500 ease-out">
                        <div className="overflow-hidden">
                          <p className="text-xs font-mono text-white/70 mb-3 uppercase tracking-widest transition-transform duration-500 delay-100">
                            {item.location}
                          </p>
                          <h3 className="text-3xl font-serif text-white mb-4 transition-transform duration-500 delay-150">
                            {item.title}
                          </h3>
                          <div className="h-auto overflow-hidden transition-all duration-500">
                            <p className="text-white/80 font-light text-sm leading-relaxed transition-opacity duration-700 delay-300 max-w-[90%]">
                              {item.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </AspectRatio>
                  </CardContent>
                </Card>
              </Link>
            </div>)}
        </div>

        {}
        <div className="mt-16 md:hidden flex justify-center">
          <Button variant="outline" className="w-full max-w-xs border-white/20" asChild>
            <Link to="/TheArchivesPage">
              Explore Archives
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}